import React, { useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { UploadFilesForm } from "../../../UploadFiles";

interface UploadButtonsProps {
	multiple?: boolean;
}

export default function UploadButtons({ multiple = false }: UploadButtonsProps) {
	const [disabled, setDisabled] = useState(true);
	const methods = useFormContext<UploadFilesForm>();
	const { register, getValues } = methods;
	const { files } = getValues();

	useEffect(() => {
		if (files) {
			if (multiple) {
				let active = files.length === 2;
				if (active) {
					const ext1 = files[0].name.split(".").pop();
					const ext2 = files[1].name.split(".").pop();
					active = [ext1, ext2].includes("xls") && [ext1, ext2].includes("zip");
				}
				setDisabled(!active);
			} else {
				const active = files.length === 1;
				setDisabled(!active);
			}
		} else {
			setDisabled(true);
		}
	}, [files]);

	return (
		<Grid container item justifyContent={"space-between"}>
			<Grid item>
				<label htmlFor="btn-upload">
					<input id="btn-upload" multiple={multiple} style={{ display: "none" }} type="file" {...register("files")} />
					<Button variant={"outlined"} component="span">
						Выберите файл
					</Button>
				</label>
			</Grid>
			<Grid item>
				<Button color="primary" variant="contained" type="submit" disabled={disabled}>
					Загрузить
				</Button>
			</Grid>
		</Grid>
	);
}
